const PARTNER_UTM_MEDIUM = "partner";

/** Returns true when the current page was reached via a partner share link. */
export function useIsPartnerShare(): boolean {
  if (typeof window === "undefined") return false;
  const raw = new URLSearchParams(window.location.search).get("utm_medium");
  return raw?.trim().toLowerCase() === PARTNER_UTM_MEDIUM;
}
